import $api from "../../axios"
import { INewProject } from "../../types/project"

const projectsPath = "/projects"

const createNewProjectData = async (project: INewProject) => {
  const response = await $api.post(projectsPath + "/upsert", project)
  return response.data
}

const getCampaignsList = async () => {
  const response = await $api.get(projectsPath + "/campaignsList")
  return response.data
}

const getProjectsList = async () => {
  const response = await $api.get(projectsPath + "/projectsList")
  return response.data
}

const addCampaignToProject = async (campaignIds: number[], projectId: string) => {
  const response = await $api.post(projectsPath + "/addCampaignsToProject", {
    campaignIds,
    projectId,
  })
  return response.data
}

const markCampaignsAsManaged = async (projectId: string, asin: string) => {
  const response = await $api.post(projectsPath + "/markCampaignsAsManaged", { projectId, asin })
  return response.data
}

const projectApi = {
  createNewProjectData,
  getCampaignsList,
  getProjectsList,
  addCampaignToProject,
  markCampaignsAsManaged,
}

export default projectApi
